const setFitScreen = () => {
    const wh = window.innerHeight;
    const ww = document.body.clientWidth;
    document.documentElement.style.setProperty("--screenHeight", `${wh}px`);
    document.documentElement.style.setProperty("--windowWidth", `${ww}px`);
    document.documentElement.style.setProperty("--windowHalfWidth", `${ww / 2}px`);
};

export { setFitScreen };
